var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.154,
    d: "M16.616 5.061a78 78 0 0 0-7.708-.384q-2.284 0-4.57.23l-1.568.154M7 4.285l.17-1.008C7.291 2.547 7.384 2 8.684 2H10.7c1.3 0 1.4.577 1.515 1.285l.17 1M14.962 7.492l-.5 7.746c-.084 1.208-.154 2.146-2.3 2.146H7.224c-2.146 0-2.216-.938-2.3-2.146l-.5-7.746M8.408 13.154h2.562M7.77 10.077h3.846"
  })));
};
export default SvgTrash;